import { useQuery } from "@tanstack/react-query";

import { getGroupForStytchOrgId } from "@/src/requests/group";

export function useGroup(orgId?: string) {
  return useQuery({
    queryKey: ["group", orgId],
    queryFn: () => {
      return getGroupForStytchOrgId(orgId!);
    },
    enabled: Boolean(orgId),
  });
}
